import { render, staticRenderFns } from "./RoboServiceDetail.vue?vue&type=template&id=637c97b2&scoped=true"
import script from "./RoboServiceDetail.vue?vue&type=script&lang=js"
export * from "./RoboServiceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637c97b2",
  null
  
)

export default component.exports